import styled from "styled-components";

export default styled.div`
  background-color: white;
  margin-right: 10px;
  border-radius: 3px;
  padding: 4px 10px;
  z-index: 0;
`;